import { Component, OnInit } from '@angular/core';
import { ClienteLogin } from '../login/cliente_login';
import { Router } from "@angular/router";
import { SessionTokenService } from "../../components/common/utils/sessionToken.service";
import { HandleError } from "../../components/common/utils/handleError.component";
import { correctHeight, detectBody, smoothlyMenu } from "../../app.helpers";
import { SessionStorageService } from "ngx-webstorage";

declare var jQuery: any;

@Component({
    selector: 'mainView',
    templateUrl: 'main-view.template.html'
})
export class mainViewComponent implements OnInit {
    usuario: ClienteLogin;
    constructor(private router: Router, private sessionTokenService: SessionTokenService, private handleError: HandleError, private sessionStorageService: SessionStorageService) { }
    ngOnInit(): void {
        /*correctHeight();
        detectBody();*/
        this.usuario = jQuery.parseJSON(this.sessionStorageService.retrieve("usuarioLogin"));
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Entrada no permitida" };
            this.handleError.redirectUrl(error);
        }
        //this.sessionTokenService.useJwtHelper();
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/main-view/main-view.component.ts